'use client';

import { Popover } from '@mui/material';

import { styled } from '../../styles';

export const StylesPopover = styled(Popover)<{ width: number }>(
  ({ theme, width }) => ({
    maxHeight: 338,
    '.MuiPaper-root': {
      padding: theme.spacing(2),
      width,
    },
  }),
);
